import { AxiosInstance } from 'axios';
import { Bank } from 'models/api/bank';

export const getBanksList = async (axios: AxiosInstance) => {
    const response = await axios.get<Bank[]>('/banks');
    return response.data;
};
